import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { switchTenant } from '../../store/slices/authSlice';
import { generateTraceId, logUserAction } from '../../utils/trace';

function TenantSwitcher() {
  const dispatch = useDispatch();
  const { tenants, activeTenant } = useSelector((state) => state.auth);
  const [isOpen, setIsOpen] = useState(false);

  if (!tenants || tenants.length <= 1) {
    return activeTenant ? (
      <span className="text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded-lg" data-testid="tenant-switcher-single">
        {activeTenant.name}
      </span>
    ) : null;
  }

  const handleSwitch = async (tenantId) => {
    const traceId = generateTraceId();
    logUserAction(traceId, 'switch_tenant', { tenantId });
    await dispatch(switchTenant({ tenantId, traceId }));
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-sm text-gray-600 bg-gray-100 px-3 py-1 rounded-lg hover:bg-gray-200 transition"
        data-testid="tenant-switcher-button"
      >
        {activeTenant?.name || 'Select Tenant'}
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 z-20" data-testid="tenant-switcher-dropdown">
            {tenants.map((tenant) => (
              <button
                key={tenant.tenant_id}
                onClick={() => handleSwitch(tenant.tenant_id)}
                className={`w-full text-left px-4 py-2 hover:bg-gray-100 first:rounded-t-lg last:rounded-b-lg ${
                  tenant.tenant_id === activeTenant?.tenant_id
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-gray-700'
                }`}
                data-testid={`tenant-option-${tenant.tenant_id}`}
              >
                <div className="font-medium">{tenant.name}</div>
                <div className="text-xs text-gray-500">Role: {tenant.role}</div>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default TenantSwitcher;
